<template>
    <div class="rounded-3xl flex flex-col" :class="{ 'gap-4': cardType === 'dialog' }">
        <div
            class="w-full px-6 md:px-10 flex flex-col gap-2 border-2 border-border-strong bg-surface-raised rounded-xl z-0"
            :class="cardType === 'onboarding' ? 'max-w-100 md:h-75 py-10 mx-auto' : 'py-3 md:py-10'">
            <div v-if="cardType !== 'dialog'" class="flex flex-row items-center gap-6">
                <!-- Lighting Icon -->
                <i class="bi bi-lightning-charge-fill text-xl text-ink-muted" aria-hidden="true"></i>
                <div class="body-small-semibold text-ink-muted">{{ title }}</div>
            </div>
            <div class="title-subsection text-ink mt-4 w-full">{{ subtitle }}</div>
            <div v-if="cardType === 'onboarding'" class="flex flex-row w-full justify-between items-center md:mt-auto mt-4">
                <BaseButton theme="tertiary" @click="$emit('seeMore')">{{ t("onboarding.insights.seeMore") }}</BaseButton>
                <BaseButton theme="primary" class="w-30 leading-6 body-small whitespace-nowrap" type="submit" @click="$emit('diveDeeper')">{{
                    t("onboarding.insights.diveDeeper")
                }}</BaseButton>
            </div>
        </div>
        <template v-if="isDialog">
            <div class="body-small text-ink-muted">{{ content }}</div>
        </template>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

type InsightsCardProps = {
    cardType: "onboarding" | "dialog";
    title: string;
    subtitle: string;
    content: string;
    id: string;
};

const props = defineProps<InsightsCardProps>();

const isDialog = computed(() => props.cardType === "dialog");

defineEmits<{
    close: [];
    diveDeeper: [];
    seeMore: [];
}>();
</script>
